var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarWithBorder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0662 0H0V18H18.0662V0Z",
    fill: "#00B67A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.03215 12.1318L11.7797 11.4381L12.9277 14.9631L9.03215 12.1318ZM15.3553 7.57559H10.5188L9.03215 3.03809L7.54545 7.57559H2.70898L6.62333 10.3881L5.13663 14.9256L9.05097 12.1131L11.4598 10.3881L15.3553 7.57559Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarWithBorder);
export default __webpack_public_path__ + "static/media/star-with-border.7e257b7c1a7d1378fe63c92822e430d5.svg";
export { ForwardRef as ReactComponent };